import React from "react";

export const Design = () => {
  return <div>Design</div>;
};
